import React, { useState, useContext, useRef, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import Image from "react-bootstrap/Image";
import Logo from "../../images/logocolor.png";
import { AuthContext } from "../../../utility/services/AuthContext";
import Functions from "../../../utility/services/Functions";
import ApiService from "../../../utility/services/ApiService";

import { toast } from "react-toastify";
import ReactLoader from "react-js-loader";

const Otp_model_for_register = (props) => {
  const phone = `+1${props.phone_number.trim()}`;
  const register_function = props.register_function;

  const { consoleService } = Functions();
  const { confirm_otp, send_otp } = ApiService();
  const { setLoading, authUserRole } = useContext(AuthContext);

  const [otpValues, setOtpValues] = useState(["", "", "", ""]);
  const inputRefs = [useRef(), useRef(), useRef(), useRef()];

  const [showOtpFields, setShowOtpFields] = useState(false);

  const [otp_loading, setOtpLoading] = useState(false);
  const [resend_code_loading, setResendCodeLoading] = useState(false);

  const otp = otpValues.join("");

  useEffect(() => {
    sendOtpFun(phone);
  }, []);

  async function sendOtpFun(phone) {
    try {
      setLoading(true);
      if (phone) {
        await send_otp({ phone, role: authUserRole });
        setShowOtpFields(true);
        setLoading(false);
      }
    } catch (err) {
      consoleService("error in sendOtpFun =  ", err);
    }
  }

  const handleInputChange = (index, value) => {
    const ModifiedValue = value.replace(/[^0-9]/g, "");
    const newOtpValues = [...otpValues];
    newOtpValues[index] = ModifiedValue;
    setOtpValues(newOtpValues);

    // Auto-focus on the next input
    if (ModifiedValue !== "" && index < inputRefs.length - 1) {
      inputRefs[index + 1].current.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    // Move to the previous input on backspace
    if (e.key === "Backspace" && index > 0 && otpValues[index] === "") {
      inputRefs[index - 1].current.focus();
    }
  };

  const resend_otp_function = async (e) => {
    try {
      e.preventDefault();
      setResendCodeLoading(true);
      await send_otp({ phone, role: authUserRole });
      clear_otp_input();
      setResendCodeLoading(false);
      toast("Otp Sent Successfully.", {
        position: "top-center",
        hideProgressBar: true,
        type: "success",
      });
    } catch (err) {
      consoleService("error in resend otp function", err);
    }
  };

  const clear_otp_input = () => {
    setOtpValues(["", "", "", ""]);
  };

  const submit_otp_fun = async () => {
    setOtpLoading(true);

    try {
      const otp_auth_res = await confirm_otp({ otp, phone });
      if (otp_auth_res.status === 1) {
        register_function(phone);
        setShowOtpFields(false);
        clear_otp_input();
        setOtpLoading(false);
        props.onHide();
      } else {
        setOtpLoading(false);
        toast("Invaild Otp.", {
          position: "top-center",
          hideProgressBar: true,
          type: "error",
        });
      }
    } catch (err) {
      setOtpLoading(false);
      consoleService("error in submit_otp_fun", err);
    }
  };

  const OtpInputs = () => {
    return (
      <Modal.Body className="otp_model_container">
        <section>
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <Form>
                  <div
                    className="loginBox loginOtpBox my-0"
                    style={{ boxShadow: "none" }}
                  >
                    <div className="text-center">
                      <Link to="">
                        <Image src={Logo} className="logo" alt="" />
                      </Link>
                      <h1>Enter OTP</h1>
                      <p>Enter the OTP sent to the number provided by you</p>
                    </div>
                    <h4>
                      OTP has been sent to <span>{phone}</span>
                    </h4>
                    <div className="formOtp mb-3">
                      {otpValues.map((value, index) => (
                        <Form.Group
                          key={index}
                          controlId={`exampleForm.ControlInput${index}`}
                        >
                          <Form.Control
                            type="text"
                            inputMode="numeric"
                            pattern="[0-9]"
                            maxLength={1}
                            placeholder=""
                            value={value}
                            onChange={(e) =>
                              handleInputChange(index, e.target.value)
                            }
                            onKeyDown={(e) => {
                              if (e.key == "Enter") {
                                otp.length == 4 && submit_otp_fun();
                              } else {
                                handleKeyDown(index, e);
                              }
                            }}
                            ref={inputRefs[index]}
                          />
                        </Form.Group>
                      ))}
                    </div>
                    <Link
                      className="conguest"
                      onClick={(e) => {
                        resend_otp_function(e);
                      }}
                    >
                      {resend_code_loading ? (
                        <ReactLoader
                          type="bubble-loop"
                          bgColor={"#1D7E7C"}
                          size={40}
                        />
                      ) : (
                        "Resend Code"
                      )}
                    </Link>
                    <Button
                      disabled={otp.length !== 4}
                      onClick={() => {
                        submit_otp_fun();
                      }}
                      className="btn btn-primary-no-hover otp_sub_btn"
                    >
                      {otp_loading ? (
                        <ReactLoader type="bubble-loop" size={40} />
                      ) : (
                        "Submit"
                      )}
                    </Button>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </section>
      </Modal.Body>
    );
  };

  return (
    <Modal
      {...props}
      size="md"
      className="modalSuccess"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      {showOtpFields && OtpInputs()}
    </Modal>
  );
};

export default Otp_model_for_register;
